import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { Iconify } from 'src/components';

// The one Call back button across Call Logs (To call back, All calls, the call review header):
// the lead tables' outlined primary row button with a phone icon. Urgency lives in the Waiting
// chip, never in the button's colour (CU-869fn2wcp).
export default function CallBackButton({ label, onClick, disabled, sx, ...rest }) {
    return (
        <Button
            size="small"
            variant="outlined"
            color="primary"
            disabled={disabled}
            onClick={onClick}
            startIcon={<Iconify icon="solar:phone-calling-rounded-linear" />}
            data-testid="call-back-button"
            // The app's global button style capitalises every word: keep "Call back".
            sx={{ fontSize: '12px', fontWeight: 600, borderRadius: '8px', whiteSpace: 'nowrap', textTransform: 'none !important', ...sx }}
            {...rest}
        >
            {label}
        </Button>
    );
}

CallBackButton.propTypes = {
    label: PropTypes.node,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    sx: PropTypes.object,
};
CallBackButton.defaultProps = { label: 'Call back', onClick: undefined, disabled: false, sx: undefined };
